var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClo1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.061 78.0607C126.646 77.4749 126.646 76.5251 126.061 75.9393L116.515 66.3934C115.929 65.8076 114.979 65.8076 114.393 66.3934C113.808 66.9792 113.808 67.9289 114.393 68.5147L122.879 77L114.393 85.4853C113.808 86.0711 113.808 87.0208 114.393 87.6066C114.979 88.1924 115.929 88.1924 116.515 87.6066L126.061 78.0607ZM23 78.5L125 78.5L125 75.5L23 75.5L23 78.5Z",
    fill: "#646464"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2278 101.928H83.8112C88.3553 101.928 92.039 98.2441 92.039 93.7V88.4052C92.039 86.7194 91.5322 85.0651 90.3715 83.8425C87.7735 81.106 82.2379 76.4954 74.4591 76.5354C66.6935 76.5754 61.2231 81.1379 58.655 83.8497C57.5017 85.0677 57 86.7142 57 88.3916V93.7C57 98.2441 60.6837 101.928 65.2278 101.928Z",
    fill: "#3AA6AA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5199,
    cy: 64.973,
    r: 13.973,
    fill: "#3AA6AA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.7111,
    cy: 63.1291,
    r: 3.61739,
    fill: "#F1F1F1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.7111,
    cy: 63.1291,
    r: 3.61739,
    fill: "#F1F1F1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.9025,
    cy: 63.1291,
    r: 3.61739,
    fill: "#F1F1F1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.9025,
    cy: 63.1291,
    r: 3.61739,
    fill: "#F1F1F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClo1);
export default __webpack_public_path__ + "static/media/clo-1.32276246d7ef5679d71331c8edbd30c0.svg";
export { ForwardRef as ReactComponent };